import Cookies from 'js-cookie';
export { Cookies };

/*
$existingCookie = $_COOKIE['prospa_utmsource'];
$urlParamUTMSource = $_GET['utm_source'];
$referrer = isset($_SERVER['HTTP_REFERER']) ? $_SERVER['HTTP_REFERER'] : $_SERVER['HTTP_HOST'];

if ($urlParamUTMSource) {

    $updatedUTMSourceCookie = $urlParamUTMSource;

} else {

    if ($existingCookie) {
        $updatedUTMSourceCookie = $existingCookie;
    } else {
        $updatedUTMSourceCookie = $referrer;
    }

}

setcookie('prospa_utmsource', $updatedUTMSourceCookie);
$_COOKIE['prospa_utmsource'] = $updatedUTMSourceCookie;

*/


let existingUTMSourceCookie = Cookies.get('prospa_utmsource');

let urlParamUTMSource = getUrlParam('utm_source');
let referrer = document.referrer ? document.referrer : location.hostname;
let utmSourceCookie;

if (urlParamUTMSource) {
    utmSourceCookie = urlParamUTMSource;
    // window.console.log('Setting prospa_utmsource cookie from URL to', utmSourceCookie);
} else {
    if (existingUTMSourceCookie) {
        // window.console.log('Found existing cookie', existingUTMSourceCookie);
        utmSourceCookie = existingUTMSourceCookie;
    } else {
        // window.console.log('Setting prospa_utmsource cookie to referrer', referrer);
        utmSourceCookie = referrer;
    }
}

Cookies.set('prospa_utmsource', utmSourceCookie);

var elementsToAttachUTMSourceTo = jQuery('.attach-data--utm-source');

for (var i in elementsToAttachUTMSourceTo) {
    if (elementsToAttachUTMSourceTo[i]) {
        if (elementsToAttachUTMSourceTo[i].href) {
            var elementURL = new URL(elementsToAttachUTMSourceTo[i].href);
            var searchParams = elementURL.searchParams;
            searchParams.set('utm_source', utmSourceCookie);
            elementURL.search = searchParams.toString();
            elementsToAttachUTMSourceTo[i].href = elementURL.toString();
        }
    }
}

// window.console.log('Attached utm_source to the following DOM elements', elementsToAttachUTMSourceTo);

// -------------------------


/*
// Attemping to set a utm_source form field
let utmSourceFormField = document.querySelectorAll('form #utm_source');

// Loop though all found utm_source form fields
[...utmSourceFormField].forEach(function(el) {
    el.value = 'Hahaha';
});
*/

